import { Inject, Injectable, NgZone } from '@angular/core';

import { Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, Subscription, fromEvent, merge, race, timer } from 'rxjs';
import { filter, map, mergeMap, repeat, switchMap, take, takeUntil, tap } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';
import { ModalController } from '@ionic/angular';
import { DialogIdleLogoutComponent } from 'src/app/components/custom/dialog-idle-logout/dialog-idle-logout.component';
import { environment } from 'src/environments/environment';



const defaultIdleTimeMinutes = environment.production ? 15 : 1;
const defaultLogoutTimeMinutes = environment.production ? 25 : 2;

@Injectable({
  providedIn: 'root'
})
export class IdleLogoutService {

  constructor(
    private router: Router,
    private auth: AuthService,
    private modalCtrl: ModalController,
    public _ngZone: NgZone,
    ) {
      this.idle$.subscribe(idle => {
        console.log('idle$ subscription: ', idle);
        console.log('idle$ idleTime: ', this.idleTimeMinutes, ', idleMilliseconds: ', this.idleMilliseconds);
        console.log('idle$ logoutTime: ', this.logoutTimeMinutes, ', logoutMilliseconds:', this.logoutMilliseconds);
      });

     }

  private stopped$: ReplaySubject<boolean> = new ReplaySubject(1);
  private resetIdleTimer$ = new BehaviorSubject(null);
  private idleCount = 0; 
  private idleCountBeforeLogout = 3; 

  idleSubscription: Subscription;
  logoutSubscription: Subscription;

  private modalIsOpen = 0;

  // time in milliseconds until modal is opened (set in watch() for kiosk vs normal users)
  private idleMilliseconds = defaultIdleTimeMinutes * 60000;
  // time in milliseconds, after modal is opened, until user is automatically logged out
  private logoutMilliseconds = defaultLogoutTimeMinutes * 60000;
  private idleTimeMinutes = defaultIdleTimeMinutes;
  private logoutTimeMinutes = defaultLogoutTimeMinutes;

  private interaction$ = merge(
    timer(0),
    this.resetIdleTimer$,
    fromEvent(window, 'mousemove'),
    fromEvent(window, 'keydown'),
    fromEvent(window, 'touchstart'),
    fromEvent(window, 'blur') // When user switches browser tab
  );

  // timer that resets on user interaction (before modal is opened)
  private idle$ = this.interaction$.pipe(switchMap(() => timer(this.idleMilliseconds)));

  // timer that resets on user interaction (after modal is opened)
  private delayLogout$ = this.interaction$.pipe(switchMap(() => timer(this.logoutMilliseconds)));

  // observable opens modal and emits when modal is closed or dismissed
  private modal$ = timer(0).pipe(
    switchMap(async () => {
       const modal = await this.modalCtrl.create({
        component: DialogIdleLogoutComponent,
        componentProps: {
          idleTime: this.idleTimeMinutes,
          logoutTime: this.logoutTimeMinutes
        }
      });

      if (this.idleCount >= this.idleCountBeforeLogout) {
        debugger
        console.log('Idle count limit reached... Logout! iLde Count: ', this.idleCount)
        this.resetIdleTimer$.next(null);
        this.idleCount = 0;
        this.auth.logout();
      } else {
          
        // Open the Model
        modal.present();
        this.modalIsOpen++;
        this.idleCount++;

        const { data, role } = await modal.onWillDismiss();
        debugger
        this.resetIdleTimer$.next(null);
        if (role === 'confirm') {
          // console.log('The confirm button was clicked. Data: ', data)
          this.modalIsOpen--;
          this.idleCount = 0;
          this.resetIdleTimer$.next(null);
        }

      }
    

      return merge(modal.onWillDismiss()).pipe(
        tap(() => {
          debugger
          this.modalIsOpen--;
          this.resetIdleTimer$.next(null);
        })
      );
    })
  )

  /**
   * Enables auto logout on a component
   */
  watch() {
    const isKiosk = this.auth.hasDepotKioskPermission();
    if (isKiosk) {
      this.idleTimeMinutes = environment.production ? 60 : 30;   // 60 or 30 min until warning
      this.logoutTimeMinutes = environment.production ? 120 : 60; // 120 or 60 min until auto logout
    } else {
      this.idleTimeMinutes = defaultIdleTimeMinutes;
      this.logoutTimeMinutes = defaultLogoutTimeMinutes;
    }
    this.idleMilliseconds = this.idleTimeMinutes * 60000;
    this.logoutMilliseconds = this.logoutTimeMinutes * 60000;

    this._ngZone.runOutsideAngular(() => {
      this.idle$.pipe(
        filter(() => !this.modalIsOpen),
        mergeMap(() => race(
          this.delayLogout$.pipe(map(() => true)),
          this.modal$.pipe(map(() => false))
        )),
        filter(result => result),
        take(1),
        takeUntil(this.stopped$),
        repeat()
      )
      .subscribe(() => {
          // Refresh the user's token when the logout timeout is reached (keeps session alive if they come back)
          this.auth.userRefreshToken().catch(() => {});
          this.resetIdleTimer();
          // console.log('Logout timeout has been reached.  this.delayLogout$: ',  this.delayLogout$)
          // console.log('Logout timeout has been reached.  this.modal$: ',  this.modal$)
          // console.log('Logout timeout has been reached.  environment:  ',  environment.production);
        }
      )
    })
 
  }

  /**
   * Call on ngOnDestroy() to prevent behavior from carrying over after component destroyed
   */
  stop() {
    this.stopped$.next(true);
    this.stopped$.complete();
    this.unsubscribeObservable();
    this.idleCount = 0;
  }

  resetIdleTimer() {
    // console.log('resetIdleTimer: ', this.idle$);
    this.resetIdleTimer$.next(null);
  }



  subscribeObservable() {
    this.idleSubscription = this.idle$.subscribe((x) => {
      console.log(`idleSubscription subcribed for ${x + 1} sec`);
     
    })

    this.logoutSubscription = this.delayLogout$.subscribe((x) => {
      console.log(`logoutSubscription subcribed for ${x + 1} sec`);
     
    })
  }

  unsubscribeObservable() {
    console.log('  unsubscriebd')
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
  }

}